import React from 'react';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="relative w-full h-screen flex items-center justify-center overflow-hidden" data-id="element-848">
      <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url('https://images.unsplash.com/photo-1582719471384-894fbb16e074?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')",
      backgroundBlendMode: 'overlay'
    }} data-id="element-849">
        <div className="absolute inset-0 bg-gray-900 opacity-60" data-id="element-850"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-851">
        <div className="max-w-3xl mx-auto" data-id="element-852">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-853">
            <span className="block" data-id="element-854">Ukweli Institute</span>
            <span className="block text-xl md:text-2xl lg:text-3xl mt-2 font-light" data-id="element-855">
              for Microbiome Research & Therapeutics
            </span>
          </h1>
          <p className="text-lg md:text-xl text-gray-200 mb-8" data-id="element-856">
            Bridging the gap between biohacker discovery, consumer wellness, and
            pharma-level science
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-857">
            <a href="#certification" className="px-6 py-3 bg-blue-600 text-white font-medium rounded-md shadow-md hover:bg-blue-700 transition-colors duration-300" data-id="element-858">
              Ukweli Certified™ Program
            </a>
            <a href="#research" className="px-6 py-3 bg-white text-blue-600 font-medium rounded-md shadow-md hover:bg-gray-100 transition-colors duration-300" data-id="element-859">
              Explore Our Research
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-10 left-0 right-0 flex justify-center" data-id="element-860">
        <a href="#about" aria-label="Scroll down" data-id="element-861">
          <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-862">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-863" />
          </svg>
        </a>
      </div>
    </section>;
};